import { Skeleton } from '@solinkcorp/solink-ui/components/ui/skeleton';

export default function SDMSkeletonGrid() {
  const skeleton = <Skeleton className="h-full w-full rounded-2xl" />;
  return (
    <div className="flex h-dvh w-full flex-col">
      <div className="grid h-full gap-4 p-4 md:grid-cols-2 md:grid-rows-[2fr_1fr_1fr]">
        <div className="md:col-span-2">{skeleton}</div>
        {skeleton}
        {skeleton}
        {skeleton}
        {skeleton}
      </div>
    </div>
  );
}
